export default "__VITE_ASSET__CnDR4mHU__"